import { ROUTER_PATH } from "@config/router";

/** `/desk/:id` — path segment 使用 encodeURIComponent */
export const buildTrackerDetailPath = (taskId: string): string =>
  `${ROUTER_PATH.DESK}/${encodeURIComponent(taskId)}`;
